import {
    DRAWINGTOOLBAR_SCALE_EDIT, DRAWINGTOOLBAR_SCALE_SHOW,
    GLOBAL_PROJECT_TYPE_CHAMBER,
    PIPE_GLOBALS_SET_SCALE_PIXELS,
    SCALELINE_END_MEASURING,
    SCALELINE_RESET,
    SCALELINE_SET_PIXELS,
    SCALELINE_START_MEASURING
} from "../lib/types";

export const startMeasuring = ( x1, y1 ) => dispatch => {
    dispatch({
        type: SCALELINE_START_MEASURING,
        payload: {x: x1, y: y1}
    });
};

export const endMeasuring = ( x2, y2 ) => dispatch => {
    dispatch({
        type: SCALELINE_END_MEASURING,
        payload: {x: x2, y: y2}
    });
    dispatch({
        type: DRAWINGTOOLBAR_SCALE_EDIT,
        payload: false
    });
};

export const emitLineLenght = length => ( dispatch, getState ) => {
    const {projectType} = getState().globals;

    dispatch({
        type: projectType === GLOBAL_PROJECT_TYPE_CHAMBER
            ? SCALELINE_SET_PIXELS
            : PIPE_GLOBALS_SET_SCALE_PIXELS,
        payload: length
    });
};

export const resetMeasurement = () => dispatch => {
    dispatch({
        type: SCALELINE_RESET
    });
};

export const showScaleLine = showScaleLine => dispatch => {
    dispatch({
        type: DRAWINGTOOLBAR_SCALE_SHOW,
        payload: showScaleLine,
    });
};



// WEBPACK FOOTER //
// ./src/actions/scaleline-actions.js